// extracted by mini-css-extract-plugin
export default {"tabs":"H1ONPPFMGU","full-width":"D-Y9Z9swZi","fullWidth":"D-Y9Z9swZi"};